var _path, _path2, _rect, _path3, _path4, _path5, _rect2, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTelavitaLogoGrey = function SvgTelavitaLogoGrey(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo_Telavita",
    "data-name": "Logo Telavita",
    width: 75,
    height: 15.054,
    viewBox: "0 0 75 15.054",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2407",
    "data-name": "Caminho 2407",
    d: "M1181.547,1347.935a2.914,2.914,0,0,1-1.235.314,1.281,1.281,0,0,1-1.34-1.465v-4.458h2.868v-2.2h-2.847v-2.658h-2.554v2.658h-1.925v2.2h1.925v4.458c0,2.574,1.465,3.851,3.7,3.768a5.71,5.71,0,0,0,2.114-.44Z",
    transform: "translate(-1119.359 -1335.686)",
    fill: "#c1c1c1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2408",
    "data-name": "Caminho 2408",
    d: "M644.087,1365.009a5.164,5.164,0,0,0-5.484,5.4c0,3.307,2.114,5.5,5.672,5.5a6.337,6.337,0,0,0,4.437-1.674l-1.633-1.612a4.257,4.257,0,0,1-2.763.963c-1.8,0-2.909-.921-3.077-2.2H649.3C649.7,1367.144,647.54,1365.009,644.087,1365.009Zm-2.8,4.27a2.78,2.78,0,0,1,2.889-2.009c1.465,0,2.512.67,2.679,2.009Z",
    transform: "translate(-628.654 -1360.902)",
    fill: "#c1c1c1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_598",
    "data-name": "Ret\\xE2ngulo 598",
    width: 2.533,
    height: 14.74,
    transform: "translate(22.013 0)",
    fill: "#c1c1c1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2409",
    "data-name": "Caminho 2409",
    d: "M835.964,1367.427a3.787,3.787,0,0,0-3.286-1.674,5.024,5.024,0,0,0-5.379,5.4c0,3.621,2.26,5.5,5.316,5.484a3.922,3.922,0,0,0,3.349-1.821l.126,1.507H838.5V1366h-2.449Zm-3.056,6.865a3.13,3.13,0,0,1,0-6.258C836.927,1368.034,836.927,1374.292,832.909,1374.292Z",
    transform: "translate(-801.433 -1361.582)",
    fill: "#c1c1c1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2410",
    "data-name": "Caminho 2410",
    d: "M1285.769,1366l-.084,1.423a3.788,3.788,0,0,0-3.286-1.674,5.024,5.024,0,0,0-5.379,5.4c0,3.621,2.26,5.5,5.316,5.484a3.922,3.922,0,0,0,3.349-1.821l.126,1.507h2.407V1366Zm-3.14,8.288a3.13,3.13,0,0,1,0-6.258C1286.648,1368.034,1286.648,1374.292,1282.63,1374.292Z",
    transform: "translate(-1213.218 -1361.582)",
    fill: "#c1c1c1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2411",
    "data-name": "Caminho 2411",
    d: "M981.506,1375.658l-3.014-7.175h-2.784l4.416,10.382h2.763l4.4-10.382H984.5Z",
    transform: "translate(-937.323 -1364.082)",
    fill: "#c1c1c1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_599",
    "data-name": "Ret\\xE2ngulo 599",
    width: 2.554,
    height: 10.361,
    transform: "translate(51.281 4.379)",
    fill: "#c1c1c1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_826",
    "data-name": "Grupo 826"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2412",
    "data-name": "Caminho 2412",
    d: "M528.029,1319.933a3.684,3.684,0,0,0-3.682-3.614h-3.686V1320h3.685v11.055h3.685v-11.126Z",
    transform: "translate(-520.661 -1316.319)",
    fill: "#c1c1c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2413",
    "data-name": "Caminho 2413",
    d: "M611.716,1320h0v-3.685h-3.685A3.685,3.685,0,0,0,611.716,1320Z",
    transform: "translate(-600.662 -1316.319)",
    fill: "#c1c1c1"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTelavitaLogoGrey, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/telavita-logo-grey.ec773b89.svg";
export { ForwardRef as ReactComponent };